import React from 'react'

import HintedLoginForm, {validations} from './HintedLoginForm'
import LoginFormContainer from 'apps/hosted-login/components/login-form-container'

const HintedLoginFormContainer = ({email, showNotification, isFederatedOnly}) => (
  <LoginFormContainer
    showNotification={showNotification}
    email={email}
    validations={isFederatedOnly ? [] : validations}>
    <HintedLoginForm isFederatedOnly={isFederatedOnly} />
  </LoginFormContainer>
)

export default HintedLoginFormContainer
